import React from 'react';

// CB:BEGIN email-preview-bid-accepted
const EmailBidAccepted: React.FC = () => {
  const nextSteps = 'Your contractor will reach out within 24 hours to schedule the work and discuss the timeline.';
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#8b5cf6', padding: 20, borderRadius: 8, marginBottom: 20, textAlign: 'center' }}>
        <h2 style={{ color: 'white', margin: 0 }}>🎉 Bid Accepted!</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Congratulations! You've successfully accepted a bid for your roofing project. This is an exciting milestone!
      </p>
      <div style={{ background: '#f3f4f6', padding: 15, borderRadius: 6, margin: '20px 0', borderLeft: '4px solid #8b5cf6' }}>
        <p style={{ fontSize: 16, fontWeight: 600, margin: 0, color: '#1f2937' }}>
          <strong>Next Steps:</strong>
        </p>
        <p style={{ fontSize: 16, margin: '10px 0 0 0', color: '#374151' }}>{nextSteps}</p>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}><strong>What happens now:</strong></p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Your contractor will contact you within 24 hours</li>
        <li>You'll discuss project timeline and scheduling</li>
        <li>Contractor will provide detailed work plan</li>
        <li>Project will begin according to agreed schedule</li>
      </ul>
      <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailBidAccepted;
// CB:END email-preview-bid-accepted


